import { useSetRecoilState } from "recoil";
import { ConfirmPopupConfig, confirmPopupState } from "../../recoil/popup/confirmPopupState";
import { ConfirmPopupResult } from "../../types/popup";

export const useConfirmPopup = () => {
  const setPopup = useSetRecoilState(confirmPopupState);

  return (
    config: Omit<ConfirmPopupConfig, "isVisible" | "resolve">
  ): Promise<ConfirmPopupResult> => {
    return new Promise((resolve) => {
      setPopup({
        headerTitle: config.headerTitle,
        message: config.message,
        discardButtonTitle: config.discardButtonTitle,
        doNotSendButtonTitle: config.doNotSendButtonTitle,
        okButtonTitle: config.okButtonTitle,
        variant: config.variant,
        isVisible: true,
        resolve,
      });
    });
  };
};
